import React, { Component } from 'react'
import EmailModal from './EmailModal'
import { get, pick } from 'lodash'
import { message } from 'antd'
import Email from '../../../api/Email'

class EmailCont extends Component {
  formRef = React.createRef()
  api = new Email()
  state = {
    email: {
      to: this.props.email.to,
      cc: this.props.email.cc,
      bcc: this.props.email.bcc,
      from: this.props.email.from,
      subject: this.props.email.subject,
      attachments: this.props.email.attachments,
    },
    files: this.props.files || [],
    template: this.props.template,
    status: this.props.status,
  }

  send = async () => {
    await this.checkForm()
    try {
      this.setState({
        sending: true,
      })
      let mail = { ...this.state.mail }

      mail.attachments = mail.attachments.map(a => this.props.files.find(f => a === f.uuid || a === f.uid ))
      await this.api.issue({
        ...mail,
        html: this.state.template,
        lines: this.props.lines,
        status: this.state.status,
      })
      this.setState({
        sending: false,
      })
      message.success('Sent')
      this.props.onCancel()
    } catch (e) {
      //console.error(e)
      message.error(e.errorMessage)
      this.setState({
        sending: false,
      })
    }
  }

  checkForm = () => {
    return new Promise((res, rej) => {
      this.formRef.current.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.setState({
            mail: values,
          })
          res(true)
        }
      })
    })
  }
  onChange = e => {
    this.setState({
      template: get(e, 'sender.body.innerHTML'),
    })
  }

  render() {


    console.log(44, this.props.email.attachments)
    return (
      <EmailModal
        {...this.props}
        {...this.state}
        {...pick(this, ['send', 'onChange', 'formRef'])}
      />
    )
  }
}

EmailCont.propTypes = {}
EmailCont.defaultProps = { email: { attachments: [] } }

export default EmailCont
